import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { validateTag } from '../validation';

import styles from './TagAutocomplete.module.css';

interface CreateTagFooterProps {
  filterText: string;
  onPress: ButtonProps['onPress'];
}

export function CreateTagFooter({ filterText, onPress }: CreateTagFooterProps) {
  const validation = validateTag(filterText);
  const isValid = validation.isValid;

  return (
    <div className={styles.footerContainer}>
      <Button variant="minimal" size="small" onPress={onPress} className={styles.actionButton} isDisabled={!isValid}>
        {isValid ? (
          <>
            <Icon name="add" size="small" />
            <span className={styles.createTagText}>Create new tag "{filterText}"</span>
          </>
        ) : (
          <span className={styles.errorText}>{validation.errorMessage}</span>
        )}
      </Button>
    </div>
  );
}
